import { CircularProgress, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getDropResumeFile,
  getDropResumeS3Key,
} from "../../../helpers/homepage_drop_resume";
import { viewFileFromS3 } from "../../../helpers/update_s3";
import { updateHomepageViewResumeDialog } from "../../../redux/actions/dialog_action";
import {
  CloseIconStyled,
  IframeStyled,
  ModalContainer,
  ModalTopContainer,
  StyledDialog,
  Text,
  TitleContainer,
} from "./styles";

export default function HomepageViewResumeDialog(props) {
  const { userResume, existingResumeUrl } = props;
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const dialogStatus = useSelector(
    (state) => state?.dialog?.showHomepageViewResumeDialog
  );

  const [pdfUrl, setPdfUrl] = useState(null);

  function handleClose() {
    dispatch(updateHomepageViewResumeDialog(false));
    setPdfUrl(null);
  }

  useEffect(() => {
    async function loadPreview() {
      if (!userResume && !existingResumeUrl) return;

      if (existingResumeUrl) {
        const normalizedUrl = existingResumeUrl.startsWith("//")
          ? `https:${existingResumeUrl}`
          : existingResumeUrl;

        if (/\.docx?(\?|$)/i.test(normalizedUrl)) {
          setPdfUrl(
            `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              normalizedUrl
            )}`
          );
        } else {
          setPdfUrl(`${normalizedUrl}#toolbar=0&navpanes=0&scrollbar=0`);
        }

        return;
      }

      const s3Key = getDropResumeS3Key(userResume);
      const file = getDropResumeFile(userResume);

      try {
        let viewUrl;
        let nameForOfficeCheck = "";

        if (s3Key) {
          nameForOfficeCheck = s3Key;
          viewUrl = await viewFileFromS3(s3Key);
        } else if (file instanceof Blob || file instanceof File) {
          nameForOfficeCheck = file.name || "";
          viewUrl = null;
        } else {
          console.error("Invalid resume state for preview");
          return;
        }

        if (viewUrl) {
          if (/(\.docx|\.doc)$/i.test(nameForOfficeCheck)) {
            setPdfUrl(
              `https://view.officeapps.live.com/op/embed.aspx?src=${viewUrl}`
            );
          } else {
            setPdfUrl(`${viewUrl}#toolbar=0&navpanes=0&scrollbar=0`);
          }
        } else if (file) {
          setPdfUrl(URL.createObjectURL(file));
        }
      } catch (error) {
        console.error("Error loading resume preview: ", error);
        if (file) {
          setPdfUrl(URL.createObjectURL(file));
        }
      }
    }

    if (dialogStatus) {
      loadPreview();
    }
  }, [dialogStatus, existingResumeUrl, userResume]);

  return (
    <StyledDialog open={dialogStatus} onClose={handleClose}>
      <ModalContainer>
        <ModalTopContainer>
          <TitleContainer>
            <Text $text={"title"}>{t("homepage.resume_view_title")}</Text>
            <CloseIconStyled onClick={handleClose} />
          </TitleContainer>
        </ModalTopContainer>

        {pdfUrl ? (
          <IframeStyled src={pdfUrl} title="PDF Viewer" width="100%" />
        ) : (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ height: "400px" }}
          >
            <CircularProgress />
          </Grid>
        )}
      </ModalContainer>
    </StyledDialog>
  );
}
